export const widthAndHeightOptions = [
  { label: '300x250', value: '300x250' },
  { label: '728x90', value: '728x90' },
  { label: '970x250', value: '970x250' },
  { label: '320x50', value: '320x50' },
  { label: '970x90', value: '970x90' },
  { label: '300x600', value: '300x600' },
];
